<template>
  <div class="Settings__main-container">
    <div class="Settings__header">
      <div class="Settings__title">Settings</div>
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" @click="closeWindow">
        <g fill-rule="evenodd">
          <path fill="none" d="M-5-5h24v24H-5z" />
          <path
            fill="#C7C7C7"
            d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z"
          />
        </g>
      </svg>
    </div>
    <div class="Settings__body">
      <div class="Settings__body-column">
        <label for="camera" class="Settings__body-label">Camera</label>
        <select
          id="camera"
          v-model="selectedCamera"
          class="Settings__body-select Settings__body-select-margin"
          @change="changeCamera"
        >
          <option
            v-for="data in cameraList"
            :key="data.deviceId"
            :value="data.deviceId"
          >{{data.label}}</option>
        </select>
        <label for="micro" class="Settings__body-label">Microphone</label>
        <select
          id="micro"
          v-model="selectedMicro"
          class="Settings__body-select"
          @change="changeAudio"
        >
          <option
            v-for="data in microList"
            :key="data.deviceId"
            :value="data.deviceId"
          >{{data.label}}</option>
        </select>
        <label for="audio" class="Settings__body-label">Audio</label>
        <select
          id="audio"
          v-model="selectedSpeaker"
          class="Settings__body-select"
          @change="changeSpeaker"
        >
          <option
            v-for="data in audioList"
            :key="data.deviceId"
            :value="data.deviceId"
          >{{data.label}}</option>
        </select>
      </div>
      <div class="Settings__body-column">
        <div class="Settings__body-video-container">
          <video
            id="localVideoSettings"
            ref="localVideoSettings"
            class="Settings__body-video"
            playsinline
            autoplay
            muted
          ></video>
        </div>

        <div class="Settings__body-micro-tenderness-container">
          <div v-for="(color, index) in microTenderness" :key="index" :class="dynamicClass(color)" />
        </div>

        <div class="Settings__body-buttons-container">
          <button class="Settings__body-button-cancel" @click="closeWindow">Cancel</button>
          <button class="Settings__body-button-save" @click="saveSettings">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  name: 'Settings',

  data() {
    return {
      microTenderness: [
        'white',
        'white',
        'white',
        'white',
        'white',
        'white',
        'white',
        'white',
      ],
      audioList: null,
      microList: null,
      cameraList: null,
      selectedCamera: null,
      selectedSpeaker: null,
      selectedMicro: null,
    }
  },

  computed: {
    ...mapState({
      tenderness: state => state.webRTC.tenderness,
      devicesList: state => state.webRTC.devicesList,
      videoDeviceId: state => state.webRTC.videoDeviceId,
      audioDeviceId: state => state.webRTC.audioDeviceId,
      speakerId: state => state.webRTC.speakerId,
    }),
  },

  watch: {
    devicesList(deviceList) {
      this.separationDevices()
    },
    tenderness(newval) {
      this.progressBar(newval)
    },
  },

  mounted() {
    this.setLocalVideoSettings({ localVideo: this.$refs.localVideoSettings })
    this.setupLocalStreamSettings({
      audio: true,
      video: { deviceId: this.videoDeviceId },
    })

    this.selectedCamera = this.videoDeviceId
    this.selectedMicro = this.audioDeviceId
    this.selectedSpeaker = this.speakerId
  },

  methods: {
    ...mapActions([
      'setupLocalStreamSettings',
      'setupLocalStream',
      'removeVideo',
    ]),

    ...mapMutations(['setLocalVideoSettings', 'changeSpeakerId']),

    progressBar(newval) {
      if (newval > 0 && newval < 100) {
        this.microTenderness = [
          'blue',
          'white',
          'white',
          'white',
          'white',
          'white',
          'white',
          'white',
        ]
      } else if (newval > 100 && newval < 200) {
        this.microTenderness = [
          'blue',
          'blue',
          'white',
          'white',
          'white',
          'white',
          'white',
          'white',
        ]
      } else if (newval > 200 && newval < 300) {
        this.microTenderness = [
          'blue',
          'blue',
          'blue',
          'white',
          'white',
          'white',
          'white',
          'white',
        ]
      } else if (newval > 300 && newval < 400) {
        this.microTenderness = [
          'blue',
          'blue',
          'blue',
          'blue',
          'white',
          'white',
          'white',
          'white',
        ]
      } else if (newval > 400 && newval < 500) {
        this.microTenderness = [
          'blue',
          'blue',
          'blue',
          'blue',
          'blue',
          'white',
          'white',
          'white',
        ]
      } else if (newval > 500 && newval < 600) {
        this.microTenderness = [
          'blue',
          'blue',
          'blue',
          'blue',
          'blue',
          'blue',
          'white',
          'white',
        ]
      } else if (newval > 600 && newval < 700) {
        this.microTenderness = [
          'blue',
          'blue',
          'blue',
          'blue',
          'blue',
          'blue',
          'blue',
          'white',
        ]
      } else if (newval > 700 && newval < 800) {
        this.microTenderness = [
          'blue',
          'blue',
          'blue',
          'blue',
          'blue',
          'blue',
          'blue',
          'blue',
        ]
      }
    },
    attachSinkId(element, sinkId) {
      if (typeof element.sinkId !== 'undefined') {
        element
          .setSinkId(sinkId)
          .then(() => {
            console.log(`Success, audio output device attached: ${sinkId}`)
          })
          .catch(error => {
            let errorMessage = error
            if (error.name === 'SecurityError') {
              errorMessage = `You need to use HTTPS for selecting audio output device: ${error}`
            }
            console.error(errorMessage)
            // Jump back to first output device in the list as it's the default.
            this.selectedSpeaker = this.audioList[0].deviceId
          })
      } else {
        console.warn('Browser does not support output device selection.')
      }
    },
    closeWindow() {
      this.$emit('closeSetting')
    },
    changeSpeaker() {
      const videoElement = document.getElementById('remoteVideo')
      this.attachSinkId(videoElement, this.selectedSpeaker)
      this.changeSpeakerId({ id: this.selectedSpeaker })
    },
    changeCamera() {
      this.setupLocalStreamSettings({
        audio: { deviceId: this.selectedMicro },
        video: { deviceId: this.selectedCamera },
      })
    },
    changeAudio() {
      this.setupLocalStreamSettings({
        audio: { deviceId: this.selectedMicro },
        video: { deviceId: this.selectedCamera },
      })
    },
    dynamicClass(color) {
      return `Settings__body-micro-circle-${color}`
    },
    saveSettings() {
      this.removeVideo()
      this.setupLocalStream({
        audio: { deviceId: this.selectedMicro },
        video: { deviceId: this.selectedCamera },
      })
      this.$emit('closeSetting')
    },
    separationDevices() {
      this.audioList = this.devicesList.filter(
        d => d.constructor.name === 'MediaDeviceInfo'
      )
      this.cameraList = this.devicesList.filter(
        d => d.constructor.name === 'InputDeviceInfo' && d.kind === 'videoinput'
      )
      this.microList = this.devicesList.filter(
        d => d.constructor.name === 'InputDeviceInfo' && d.kind === 'audioinput'
      )
      if (!this.selectedSpeaker) {
        this.selectedSpeaker = this.audioList[0].deviceId
      }
      if (!this.selectedCamera) {
        this.selectedCamera = this.cameraList[0].deviceId
      }
      if (!this.selectedMicro) {
        this.selectedMicro = this.microList[0].deviceId
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import 'Settings';
</style>
